<template>
  <form ref="my-form" class="user" :id="item.slug" @submit.prevent="">
    <template v-for="attribute in attributes">
      <div v-if="isHidden(attribute)" :key="attribute.id">
        
        <!-- Classic inputs type -->
        <Input v-if="attribute.input == 'text' || attribute.input == 'number'" :item="attribute" @selected="getData" />
        <Select v-if="attribute.input == 'select'" :item="attribute" @selected="getData" />     
        <CheckBox v-if="attribute.input == 'checkbox'" :item="attribute" @selected="getData" />
        <Radio v-if="attribute.input == 'radio'" :item="attribute" @selected="getData" />
        
        <!-- Form upload -->
        <FormFileUpload v-if="attribute.input == 'upload'" :item="attribute" @selected="getData" />    

        <!-- Location -->  
        <Location v-if="attribute.input == 'location'" :item="attribute" :map="getMap()" @selected="getData" />

        <!-- DateTime Fields -->
        <DateTimeField v-if="attribute.input == 'date'" :item="attribute" @selected="getData" />    
        <DateTimeField v-if="attribute.input == 'datetime'" :hasTime="true" :item="attribute" @selected="getData" />

      </div>
    </template>
  </form>
</template>

<script>
import Input from '@/components/Form/FormItem/Input.vue'
import Select from '@/components/Form/FormItem/Select.vue'
import CheckBox from '@/components/Form/FormItem/CheckBox.vue'
import Radio from '@/components/Form/FormItem/Radio.vue'
import FormFileUpload from '@/components/Form/FormItem/FormFileUpload.vue'
import DateTimeField from '@/components/Form/FormItem/DateTimeField.vue'
export default {
  name: 'Formulaire',
  props: ['item'],
  components: {
    Input,
    Select,
    CheckBox,
    Radio,
    FormFileUpload,
    Location,
    DateTimeField
  },
  created() {
    this.token = this.$cookie.get('gestionnaire');

    if(!this.item.slug || this.item.slug.length <= 0){
      this.item.slug = 'my-form'
    }

    this.attributes = this.item.attributes;
    this.attributes.sort(function(a, b) {
      if (a.priority > b.priority) return 1
      if (a.priority < b.priority) return -1
      return 0
    })
  },
  data: function() {
    return {
      attributes: [],
      token:''
    }
  },
  methods: {
    isHidden(attribute){
      if(this.token && this.token.length > 0){
        return true;
      }

      return attribute.hidden === 0
    },
    getData(data) {
      this.validate();
      this.$emit('selected', data);
    },
    getMap: function() {
      return this.$store.state.map;
    },
    validate: function(event) {
      var form = this.$refs['my-form'];
      if (form.checkValidity() === false) {
        this.$emit('invalidated');
      } else {
        this.$emit('validated');        
      }
      form.classList.add('was-validated');
    }
  }
}
</script>
